import React from "react";
import ServicesSection from "../components/ServicesSection";
import SEO from "../components/SEO";

const ServicesPage = () => (
  <>
    <SEO
      title="Piattaforma Kyros | Giochi autoprodotti, Store e launcher"
      description="Kyros Games sviluppa e distribuisce i propri videogame tramite Store, account e launcher."
      canonical="https://kyrosgames.com/services"
      structuredData={{
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "WebPage",
            "@id": "https://kyrosgames.com/services#webpage",
            "url": "https://kyrosgames.com/services",
            "name": "Piattaforma Kyros | Giochi autoprodotti, Store e launcher",
            "inLanguage": "it-IT",
            "isPartOf": { "@id": "https://kyrosgames.com/#website" },
            "breadcrumb": { "@id": "https://kyrosgames.com/services#breadcrumb" }
          },
          {
            "@type": "BreadcrumbList",
            "@id": "https://kyrosgames.com/services#breadcrumb",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://kyrosgames.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Piattaforma Kyros",
                "item": "https://kyrosgames.com/services"
              }
            ]
          }
        ]
      }}
    />
    <ServicesSection />
  </>
);

export default ServicesPage;
